import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';
import Buttons from '../Buttons';

const StyledEvent = styled.div`
  color: ${props => props.theme.colors.dark};
  cursor: pointer;
  font-size: ${rem('14px')};
  margin-bottom: 0.625rem;
  overflow: hidden;
  padding: 0 ${rem('40px')};
  position: relative;
  min-height: 2.5rem;
  ${props =>
    props.acceptedEvent &&
    css`
      color: ${props.theme.colors.gray};
    `};
`;

const StyledName = styled.div`
  font-family: ${props => props.theme.fonts.medium};
  margin-bottom: ${rem('2px')};
  max-height: ${rem('25px')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 ${rem('5px')} 0 0;
  ${mediaqueries.greaterThan('mobile')`
    padding: 0 ${rem('15px')} 0 0;
  `};
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${props => props.theme.fontSize.small};
  `};
`;

const StyledDate = styled(StyledName)``;

const StyledUser = styled(StyledName)``;

const StyledTitle = styled(StyledName)``;

const StyledDesc = styled(StyledName)``;

const StyledEventRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 ${rem('-5px')} 0 0;
  overflow: hidden;
  align-items: center;
`;

const StyledParcelEvent = styled(StyledEvent)`
  ${StyledEventRow} {
    &:first-child {
      ${StyledUser} {
        flex: 1;
        text-align: right;
      }
      ${mediaqueries.greaterThan('480px')`
        flex: 1;
        justify-content: flex-start;
        margin: 0;
        ${StyledUser}{
          text-align: left;
        }
      `};
    }
  }
  ${mediaqueries.greaterThan('480px')`
    display: flex;
    flex-wrap: wrap;
  `};
  ${mediaqueries.greaterThan('mobile')` 
    justify-content: space-between;
  `};
`;

const StyledGeneralEvent = styled(StyledEvent)`
  display: block;
  ${StyledTitle} {
    flex: 1;
    text-align: left;
    ${mediaqueries.greaterThan('mobile')` 
      padding-right:${rem('5px')};
    `};
  }
  ${StyledDesc} {
    flex: 1;
    text-align: left;
  }
  ${StyledUser}, ${StyledDate} {
    width: ${rem('100px')};
  }
`;

const StyledIconContent = styled.div`
  position: relative;
  padding-left: ${rem('33px')};
`;

const FirstElementEvent = styled.div`
  align-items: center;
  display: flex;
`;

const StyledIcons = styled(Icon)`
  position: absolute;
  top: 0;
  width: ${rem('23px')};
  left: 0;
  height: ${rem('23px')};
`;

const StyledLayer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  min-height: ${rem('55px')};
`;

const StyledLayerShort = styled.div`
  min-width: ${rem('141px')};
`;

const StyledLayerRight = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${mediaqueries.greaterThan('mobile')`
    align-items: flex-end;
    flex-direction: column-reverse;
    justify-content: flex-end;
    width: auto;
  `};
`;

const StyledCity = StyledName.extend``;
const StyledDayHours = StyledName.extend``;

const StyledCourse = StyledName.extend`
  margin-bottom: 0;
  text-transform: uppercase;
`;

const StyledBoxInterior = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.primary};
  display: ${props => (props.showOptions === true ? 'flex' : 'none')};
  flex-flow: wrap column;
  height: 100%;
  justify-content: center;
  left: ${props => (props.showOptions === true ? 0 : 'calc(100 % - 0.25rem))')};
  top: 0;
  position: absolute;
  transition: all 0.25s ease-in-out 0.2s;
  width: 100%;
  z-index: 2;

  ${mediaqueries.greaterThan('mobile')`
    display: flex;
    flex-flow: initial;
    padding: 0 ${rem('40px')};
    &:after {
      content: none;
    }
  `};
`;

const StyledBoxInteriorButtonMessage = StyledBoxInterior.extend`
  flex-flow: row wrap;
`;

const StyledIconOk = styled(Icon)`
  margin: 0 0 ${rem('12px')} 0;
  ${mediaqueries.greaterThan('mobile')`
    margin: 0 ${rem('12px')} 0 0;
  `};
`;

const StyledText = styled.p`
  color: ${props => props.theme.colors.light};
  font-family: ${props => props.theme.fonts.medium};
  font-size: inherit;
  margin: 0;
  text-align: center;

  ${mediaqueries.greaterThan('mobile')`
    font-size: ${props => props.theme.fontSize.small};
    text-align: left;
  `};
`;

const ButtonsEvent = styled(Buttons)`
  margin: 0 0.5rem;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    right: 30px;
  }
`;

const StyledCheck = styled.div`
  align-items: center;
  display: flex;
  flex-flow: column;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.xsmall};
  justify-content: center;
  line-height: 1.2;
  margin: 0 ${rem('10px')};
`;

const StyledBoxDown = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${rem('23px')};
  padding: 0 ${rem('30px')} 0 ${rem('40px')};
`;

const StyledLink = styled.a`
  color: ${props => props.theme.colors.gray};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.large};
  padding-bottom: ${rem('4px')};

  ${mediaqueries.greaterThan('mobile')`
    font-size: inherit;
  `};

  ${mediaqueries.greaterThan('desktop')`
    font-size: ${props => props.theme.fontSize.small};
  `};
`;

const StyledIconCollapseDown = styled(Icon)`
  position: absolute;
  right: ${rem('41px')};
  top: ${rem('-6px')};
  z-index: 3;

  ${mediaqueries.greaterThan('mobile')`
    display: none
  `};
`;

const StyledTag = styled.div`
  background-color: ${props => props.theme.colors.grayLight};
  border-radius: ${rem('100px')};
  color: ${props => props.theme.colors.dark};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.xsmall};
  height: ${rem('20px')};
  line-height: ${rem('20px')};
  padding: 0 ${rem('9px')};
  margin: 0 ${rem('5px')};

  ${props =>
    props.acceptedEvent &&
    css`
      background-color: ${props => props.theme.colors.gray};
    `};
`;

const StyledPrice = styled.div`
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${props => props.theme.fontSize.large};
  margin-bottom: ${rem('3px')};

  ${mediaqueries.greaterThan('mobile')`
    font-size: inherit;
  `};
`;

const StyledIconDot = styled.span`
  margin-left: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
  height: 10px;
  width: 10px;
  display: inline-block;
  ${props =>
    props.viewed === false &&
    `
    border-radius: 50%;
    border-style: solid;
    border-width: 0.5px;
    border-color: ${props.theme.colors.primary};
    
    background-color: ${props.theme.colors.primary};
  `};
`;

export {
  StyledEvent,
  StyledParcelEvent,
  StyledGeneralEvent,
  StyledDate,
  StyledTitle,
  StyledDesc,
  StyledUser,
  StyledIconContent,
  StyledEventRow,
  FirstElementEvent,
  StyledIcons,
  StyledLayer,
  StyledLayerShort,
  StyledLayerRight,
  StyledName,
  StyledCity,
  StyledDayHours,
  StyledCourse,
  StyledBoxInterior,
  StyledBoxInteriorButtonMessage,
  StyledIconOk,
  StyledText,
  ButtonsEvent,
  StyledCheck,
  StyledBoxDown,
  StyledLink,
  StyledIconCollapseDown,
  StyledTag,
  StyledPrice,
  StyledIconDot
};
